import VueGtag from "vue-gtag";

// Route params and query keys that carry one-time tokens or OAuth codes.
// Their values (an email confirmation token embeds the user's email) must never reach analytics.
const TOKEN_PARAMS = ["token"];
const SENSITIVE_QUERY_KEYS = ["code", "state", "token", "request_id"];

function sanitizedPath(route) {
    const record = route.matched && route.matched[route.matched.length - 1];
    const params = route.params || {};
    if (!record || !TOKEN_PARAMS.some((name) => params[name])) {
        return route.path;
    }
    return record.path.replace(/:(\w+)/g, (placeholder, name) =>
        TOKEN_PARAMS.includes(name) || params[name] == null ? placeholder : encodeURIComponent(params[name])
    );
}

function sanitizedQuery(query) {
    const search = new URLSearchParams();
    Object.keys(query || {}).forEach((key) => {
        if (SENSITIVE_QUERY_KEYS.includes(key.toLowerCase())) return;
        [].concat(query[key]).forEach((value) => {
            if (value != null) search.append(key, value);
        });
    });
    const result = search.toString();
    return result ? `?${result}` : "";
}

/**
 * GA4 page parameters for a route with token values replaced by their placeholder
 * (e.g. /email_confirmed/:token) and OAuth/token query keys removed.
 */
export function analyticsPage(route, origin) {
    const path = sanitizedPath(route);
    return {
        page_title: route.name,
        page_path: path,
        page_location: `${origin}${path}${sanitizedQuery(route.query)}`,
    };
}

/**
 * GA4 via vue-gtag with sanitized page views. Events fired on a page (e.g. email_confirmed)
 * report its location too, so the sanitized location is also set before each page's events.
 */
export function installAnalytics(Vue, router, { id, enabled }) {
    const pageParams = (route) => analyticsPage(route, window.location.origin);
    Vue.use(VueGtag, { config: { id }, enabled, pageTrackerTemplate: pageParams }, router);
    router.afterEach((to) => Vue.$gtag.set(pageParams(to)));
}
